// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
import bemify from 'bemify-js';

import AccountDropdownToggler from 'app/common/components/AccountDropdownToggler';
import AccountSwitcherContainer from 'app/viewport/components/AccountSwitcherContainer';
import DropdownMenu from 'app/common/components/DropdownMenu';
import DropdownStateful from 'app/common/components/DropdownStateful';
import createRenderCallback from 'app/common/components/createRenderCallback';
import { Div } from 'app/common/components/AccessibleElement';
import { MenuSection } from 'app/common/components/Menu';
import 'app/common/components/AppNavAccountSwitcherDropdown.scss';

const bem = bemify('app-nav-account-switcher-dropdown');

const AppNavAccountSwitcherDropdownToggle = ({
  accountId,
  accountName,
  onClick,
}) => {
  return (
    <Div className={bem('__dropdown-toggler-wrapper')} onClick={onClick}>
      <AccountDropdownToggler
        accountId={accountId}
        className={bem('__dropdown-toggler')}
        kind="strong"
        title={accountName}
      />
    </Div>
  );
};

const AppNavAccountSwitcherDropdownMenu = ({
  items,
  onChoose,
  onClickOutside,
}) => {
  return (
    <DropdownMenu
      className={bem('__dropdown-menu')}
      kind="below justify-left"
      onChoose={onChoose}
      onClickOutside={onClickOutside}
    >
      <AccountSwitcherContainer isStandalone={false} />
      <MenuSection items={items} />
    </DropdownMenu>
  );
};

const AppNavAccountSwitcherDropdown = ({ accountId, accountName, items }) => {
  return (
    <DropdownStateful
      className={bem('__dropdown-wrapper')}
      items={items}
      renderMenu={createRenderCallback(AppNavAccountSwitcherDropdownMenu)}
      renderToggle={createRenderCallback(AppNavAccountSwitcherDropdownToggle, {
        accountId,
        accountName,
      })}
    />
  );
};

AppNavAccountSwitcherDropdown.propTypes = {
  accountId: PropTypes.number,
  accountName: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
};

export default AppNavAccountSwitcherDropdown;
